export default __webpack_public_path__ + "static/media/p27.b9ecf861.jpg";